import React from "react";
import { Outlet } from "react-router";
import { Sidebar } from "../sidebar";
import {Helmet} from "react-helmet";
import { getPageTitle } from "../../helpers/envTitle";


import "./style.css";


export const Layout = () => {
  return (
    <div className={"layout"}>
        <Helmet>
            <title>{getPageTitle()}</title>
            <meta name="description" content="Build your own visuals with Gifalot" />
            <meta name="application-name" content={"Gifalot"} />
        </Helmet>
      <Sidebar />
      <Outlet />
    </div>
  );
};
